/**
 *
 * File: ActionsRequest.js
 *
 */
(function () {
    angular
        .module('maApp.remoteRequests')
        .factory('ActionsRequest', ActionsRequest);

    ActionsRequest.$inject = ['APIRequest'];

    function ActionsRequest(APIRequest) {

        var request = new APIRequest.Request(
            '{{endpoint}}managementactions/',
            '{{endpoint}}managementactions/{{id}}/'
        );

        var collectionUrl = request.collectionUrl();

        return {
            'get': read,
        };

        function read(options){
            options = options || {};
            var params = {};
            if('active' in options){
                params.currentsiteind = options.active;
            }
            return APIRequest.get({
                url: collectionUrl,
                'params': params
            })
                .then(APIRequest.commonSucceed, APIRequest.createCommonFail('Failed to fetch actions'));
        }


    }
})();